/**
 * We not implementing cancellation for now due to time limitations.
 * But it is planned
 */
export const CANCELLATION_ENABLED = false;

/**
 * This value was used for testing purposes
 */
export const TRAVEL_RULE_ENABLED = true;
